export default {
  TableHeadPasswordLog: [
    [
      {
        displayName: 'reset_password_log.table_head.operator',
      },
      {
        displayName: 'reset_password_log.table_head.role',
      },
      {
        displayName: 'reset_password_log.table_head.user',
      },
      {
        displayName: 'reset_password_log.table_head.role',
      },
      {
        displayName: 'reset_password_log.table_head.timestamp',
      },
      {
        displayName: 'reset_password_log.table_head.ip_address',
      },
    ],
  ],
};
